document.addEventListener('DOMContentLoaded', function() {
  // Image gallery swap
  var mainImage = document.getElementById('mainImage');
  var thumbs = document.querySelectorAll('.product-gallery-thumb');
  if (mainImage && thumbs.length > 0) {
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var thumbImg = thumb.querySelector('img');
        if (thumbImg) {
          var tempSrc = mainImage.src;
          var tempAlt = mainImage.alt;
          mainImage.src = thumbImg.src;
          mainImage.alt = thumbImg.alt;
          thumbImg.src = tempSrc;
          thumbImg.alt = tempAlt;
        }
      });
    });
  }

  // Scroll-triggered animations
  var animateElements = document.querySelectorAll('.animate-in');
  if (animateElements.length > 0 && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    animateElements.forEach(function(el) {
      observer.observe(el);
    });
  }

  // Sticky mobile buy bar — show after scrolling past hero
  var hero = document.querySelector('.hero');
  var stickyBar = document.getElementById('stickyBar');
  if (hero && stickyBar && 'IntersectionObserver' in window) {
    stickyBar.style.transform = 'translateY(100%)';
    stickyBar.style.transition = 'transform 0.3s ease';

    var stickyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) {
          stickyBar.style.transform = 'translateY(0)';
        } else {
          stickyBar.style.transform = 'translateY(100%)';
        }
      });
    }, { threshold: 0 });

    stickyObserver.observe(hero);
  }
});
